<template>
    <div class="inj-donut">
        <div class="inj-donut-wrap">
            <doughnut-chart :labels="labels" :datasets="datasets" :styles="donutStyles" show-percentage />
            <div class="inj-donut-center">
                <div class="inj-donut-val">{{ distinctCount }}</div>
                <div class="inj-donut-lbl">{{ centerLabel }}</div>
            </div>
        </div>
        <div class="inj-donut-legend" :class="{ 'inj-donut-legend--cols': legend.length >= 5 }">
            <div v-for="(item, i) in legend" :key="i" class="inj-donut-legend-row">
                <span class="inj-donut-legend-dot" :style="{ background: item.color }" />
                <span class="inj-donut-legend-name">{{ item.name }}</span>
                <span class="inj-donut-legend-pct">{{ item.pct }}%</span>
            </div>
        </div>
    </div>
</template>

<script>
import DoughnutChart from '../../common/DoughnutChart.vue'

export default {
    name: 'InjuryDonut',
    components: { DoughnutChart },
    props: {
        docs: {
            type: Array,
            default: () => [],
        },
        field: {
            type: String,
            required: true,
        },
        colors: {
            type: Array,
            default: () => [],
        },
        centerLabel: {
            type: String,
            default: '',
        },
        labelFn: {
            type: Function,
            default: null,
        },
    },
    computed: {
        counts(vm = this) {
            const counts = {}
            vm.docs.forEach(doc => {
                const value = doc[vm.field]
                if (!value) return
                const key = vm.labelFn ? vm.labelFn(value) : value
                counts[key] = (counts[key] || 0) + 1
            })
            return counts
        },
        distinctCount(vm = this) {
            return Object.keys(vm.counts).length
        },
        entries(vm = this) {
            const total = vm.docs.length || 1

            let others = 0
            const filtered = {}
            Object.entries(vm.counts).forEach(([key, value]) => {
                const pct = parseFloat((value / total * 100).toFixed(1))
                pct < 5 ? others += pct : filtered[key] = pct
            })
            if (others > 0) filtered[vm.$t('common.others')] = parseFloat(others.toFixed(1))

            return Object.entries(filtered).map(([name, pct], i) => ({
                name,
                pct,
                color: vm.colors[i % vm.colors.length],
            }))
        },
        labels(vm = this) {
            return vm.entries.map(e => e.name)
        },
        datasets(vm = this) {
            return [{
                data: vm.entries.map(e => e.pct),
                backgroundColor: vm.entries.map(e => e.color),
                borderWidth: 0,
            }]
        },
        legend(vm = this) {
            return vm.entries
        },
        donutStyles() {
            return { position: 'relative', height: '100%', width: '100%' }
        },
    },
}
</script>

<style scoped>
.inj-donut {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
}

.inj-donut-wrap {
    position: relative;
    flex: 1;
    min-height: 0;
}

.inj-donut-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    pointer-events: none;
}

.inj-donut-val {
    font-size: 22px;
    font-weight: 800;
    color: var(--v-txtPrimary-base);
    line-height: 1;
}

.inj-donut-lbl {
    font-size: 10px;
    font-weight: 500;
    color: var(--v-txtMuted-base);
}

.inj-donut-legend {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-top: 8px;
    flex-shrink: 0;
}

.inj-donut-legend--cols {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 4px 12px;
}

.inj-donut-legend-row {
    display: flex;
    align-items: center;
    gap: 7px;
    font-size: 10px;
    font-weight: 500;
    color: var(--v-txtSecondary-base);
}

.inj-donut-legend-dot {
    width: 8px;
    height: 8px;
    border-radius: 2px;
    flex-shrink: 0;
}

.inj-donut-legend-name {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.inj-donut-legend-pct {
    margin-left: auto;
    font-weight: 700;
    color: var(--v-txtPrimary-base);
}
</style>
